var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDel2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Door"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.75 20.25H19.5V3.75C19.5 3.35218 19.342 2.97064 19.0607 2.68934C18.7794 2.40804 18.3978 2.25 18 2.25H6C5.60218 2.25 5.22064 2.40804 4.93934 2.68934C4.65804 2.97064 4.5 3.35218 4.5 3.75V20.25H2.25C2.05109 20.25 1.86032 20.329 1.71967 20.4697C1.57902 20.6103 1.5 20.8011 1.5 21C1.5 21.1989 1.57902 21.3897 1.71967 21.5303C1.86032 21.671 2.05109 21.75 2.25 21.75H21.75C21.9489 21.75 22.1397 21.671 22.2803 21.5303C22.421 21.3897 22.5 21.1989 22.5 21C22.5 20.8011 22.421 20.6103 22.2803 20.4697C22.1397 20.329 21.9489 20.25 21.75 20.25ZM6 3.75H18V20.25H6V3.75ZM15.75 12.375C15.75 12.5975 15.684 12.815 15.5604 13C15.4368 13.185 15.2611 13.3292 15.0555 13.4144C14.85 13.4995 14.6238 13.5218 14.4055 13.4784C14.1873 13.435 13.9868 13.3278 13.8295 13.1705C13.6722 13.0132 13.565 12.8127 13.5216 12.5945C13.4782 12.3762 13.5005 12.15 13.5856 11.9445C13.6708 11.7389 13.815 11.5632 14 11.4396C14.185 11.316 14.4025 11.25 14.625 11.25C14.9234 11.25 15.2095 11.3685 15.4205 11.5795C15.6315 11.7905 15.75 12.0766 15.75 12.375Z",
    fill: "#3D5A80"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel2);
export default __webpack_public_path__ + "static/media/del2.4caf27218b605da4e855ad028a18a52f.svg";
export { ForwardRef as ReactComponent };